<template>
    <div>
        <div class="header">Informations de l'utilisateur</div>
        <v-form ref="form" v-model="valid">
            <v-row>
                <v-col cols="6">
                    <v-text-field-filled
                        label="Nom"
                        v-model="user_.lastname"
                        :rules="lastNameRules"
                        :error="isLastnameError"
                        :error-messages="lastnameErrorMessage"
                        hide-details="auto"
                    />
                </v-col>
                <v-col cols="6">
                    <v-text-field-filled
                        label="Prénom"
                        v-model="user_.name"
                        :rules="nameRules"
                        :error="isNameError"
                        :error-messages="nameErrorMessage"
                        hide-details="auto"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <v-text-field-filled
                        label="E-mail"
                        type="email"
                        v-model="user_.email"
                        :rules="emailRules"
                        :error="isEmailError"
                        :error-messages="emailErrorMessage"
                        hide-details="auto"
                    />
                </v-col>
                <v-col cols="6">
                    <v-text-field-filled
                        label="Numéro de téléphone"
                        v-model="user_.phoneNumber"
                        :rules="phoneNumberRules"
                        :error="isPhoneNumberError"
                        :error-messages="phoneNumberErrorMessage"
                        hide-details="auto"
                    />
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script lang="ts">
import { userInfo } from "@/types/registerServices.types";
import { Component, Vue, toNative, Watch, Model, Emit } from "vue-facing-decorator";

@Component
export class UserForm extends Vue {
    @Model({ default: null, name: "user" }) user_: userInfo;

    valid: boolean = true;

    @Watch("valid")
    update() {
        this.userFormValidation();
    }

    @Emit
    userFormValidation() {
        return this.valid;
    }

    @Watch("user.email")
    refreshEmailError() {
        this.user_.error.email = "";
    }

    @Watch("user.phoneNumber")
    refreshPhoneNumberError() {
        this.user_.error.phoneNumber = "";
    }

    @Watch("user.name")
    refreshNameError() {
        this.user_.error.name = "";
    }

    @Watch("user.lastname")
    refreshLastnameError() {
        this.user_.error.lastname = "";
    }

    get lastNameRules() {
        return [(v) => !!v || "Le nom est manquant"];
    }

    get nameRules() {
        return [(v) => !!v || "Le prénom est manquant"];
    }

    get emailRules() {
        return [
            (v) => !!v || "L'email est manquant",
            (v) => /.+@.+\..+/.test(v) || "L'email doit être valide",
        ];
    }

    get phoneNumberRules() {
        return [(v) => !!v || "Le numéro de téléphone est manquant"];
    }

    get isNameError() {
        if (this.user_.error?.email?.length) {
            this.valid = false;
            return true;
        }
        return false;
    }

    get nameErrorMessage() {
        return this.user_.error?.name?.length ? this.user_.error.name : "";
    }

    get isLastnameError() {
        if (this.user_.error?.lastname?.length) {
            this.valid = false;
            return true;
        }
        return false;
    }

    get lastnameErrorMessage() {
        return this.user_.error?.lastname?.length ? this.user_.error.lastname : "";
    }

    get isEmailError() {
        if (this.user_.error?.email?.length) {
            this.valid = false;
            return true;
        }
        return false;
    }

    get emailErrorMessage() {
        return this.user_.error?.email?.length ? this.user_.error.email : "";
    }

    get isPhoneNumberError() {
        if (this.user_.error?.phoneNumber?.length) {
            this.valid = false;
            return true;
        }
        return false;
    }

    get phoneNumberErrorMessage() {
        return this.user_.error?.phoneNumber?.length ? this.user_.error.phoneNumber : "";
    }
}

export default toNative(UserForm);
</script>

<style scoped>
.header {
    text-align: center;
    margin-bottom: 2vh;
    font-weight: bold;
}
</style>
